import axios, { AxiosInstance } from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL
  ? import.meta.env.VITE_API_URL
  : import.meta.env.VITE_API_GATEWAY_URL
  ? `${import.meta.env.VITE_API_GATEWAY_URL.replace(/\/\/+$/, "")}/api`
  : "http://localhost:8000/api";
const FIELD_RECRUITERS_BASE_URL = `${API_BASE_URL.replace(/\/\/+$/, "")}/v1/field-recruiters`;

export type FieldRecruiterStatus = "ACTIVE" | "INACTIVE";

export interface FieldRecruiter {
  id: string;
  employeeId: string;
  name: string;
  phone: string;
  email: string;
  city: string;
  status: FieldRecruiterStatus;
  updatedBy?: string | null;
  updatedOn?: string;
}

export interface CreateFieldRecruiterRequest {
  employeeId: string;
  name: string;
  phone: string;
  email: string;
  city: string;
  status: FieldRecruiterStatus;
}

export type UpdateFieldRecruiterRequest = Partial<CreateFieldRecruiterRequest>;

export interface FieldRecruiterListParams {
  search?: string;
  city?: string;
  status?: FieldRecruiterStatus;
  page?: number;
  limit?: number;
}

const fieldRecruiterApi: AxiosInstance = axios.create({
  baseURL: FIELD_RECRUITERS_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

fieldRecruiterApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class FieldRecruiterService {
  async getFieldRecruiters(params?: FieldRecruiterListParams) {
    const response = await fieldRecruiterApi.get("/", { params });
    return response.data;
  }

  async createFieldRecruiter(payload: CreateFieldRecruiterRequest) {
    const response = await fieldRecruiterApi.post("/", payload);
    return response.data;
  }

  async updateFieldRecruiter(id: string, payload: UpdateFieldRecruiterRequest) {
    const response = await fieldRecruiterApi.put(`/${encodeURIComponent(id)}`, payload);
    return response.data;
  }

  async deleteFieldRecruiter(id: string) {
    const response = await fieldRecruiterApi.delete(`/${encodeURIComponent(id)}`);
    return response.data;
  }
}

export const fieldRecruiterService = new FieldRecruiterService();
export default fieldRecruiterService;
